{
  "error_add_source": "Impossible d'ajouter la source :",
  "streamerror": "Une erreur s’est produite lors du chargement de la liste, essayer à nouveau?",
  "source_warn": "Voulez-vous vraiment supprimer cette source?",
  "sources": "Sources",
  "timestamp": "{0,date} {0,time}",
  "close_entry": "Fermer",
  "error_share_native": "Impossible de partager l'élément.",
  "error_share_native_abort": "Impossible de partager l'élément, soit il n'y a pas de cible, soit vous avez annulé le partage.",
  "share_copy_label": "Copier le lien dans le presse-papiers",
  "share_mail_label": "Partager par courriel",
  "share_wordpress_label": "Partager sur WordPress",
  "share_wallabag_label": "Enregistrer dans Wallabag",
  "share_pocket_label": "Enregistrer dans Pocket",
  "share_facebook_label": "Partager sur Facebook",
  "share_twitter_label": "Partager sur Twitter",
  "share_diaspora_label": "Partager sur Diaspora",
  "share_native_label": "Partager",
  "info_url_copied": "URL copiée dans le presse-papiers.",
  "error_configuration": "Impossible de charger la configuration.",
  "article_actions": "Actions",
  "search_label": "Terme de recherche",
  "error_invalid_subsection": "Sous-section erronée :",
  "error_offline_storage": "Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est désactivé pour le moment.",
  "error_sync": "Impossible de synchroniser les dernières modifications du serveur :",
  "error_refreshing_source": "Impossible de rafraîchir les sources :",
  "error_saving_color": "Impossible de sauvegarder une nouvelle couleur :",
  "error_loading_stats": "Impossible de charger les statistiques de navigation :",
  "error_loading": "Erreur de chargement :",
  "error_logout": "Impossible de se déconnecter :",
  "error_star_item": "Erreur lors de l’ajouter/suppression du favori :",
  "error_mark_item": "Erreur lors du marquage lu/non lu :",
  "error_mark_items": "Impossible de marquer tous les éléments visibles :",
  "error_unknown_source": "Identifiant de source inconnu :",
  "error_unknown_tag": "Tag inconnu :",
  "error_load_tags": "Impossible de charger les étiquettes :",
  "error_delete_source": "Impossible de supprimer la source :",
  "error_session_expired": "Session expirée",
  "app_reload": "Recharger",
  "app_update": "selfoss a été mis à jour, merci de recharger",
  "sources_refreshed": "Sources actualisées",
  "reload_list": "Recharger la liste",
  "error": "Une erreur est survenue",
  "no_title": "Sans titre",
  "login_offline": "Stockage hors-ligne",
  "login_invalid_credentials": "Nom d’utilisateur/Mot de passe incorrect",
  "login_password": "Mot de passe",
  "login_username": "Identifiant",
  "login": "Connexion",
  "more": "Plus",
  "no_entries": "Aucun article à consulter",
  "source_refresh": "Rafraîchir cette source",
  "source_last_post": "Dernier élément vu",
  "source_saved": "Enregistré",
  "source_cancel": "Annuler",
  "source_save": "Enregistrer",
  "source_type": "Type",
  "source_select": "Veuillez sélectionner une source",
  "source_comma": "Séparés par une virgule",
  "source_pwd_placeholder": "Mot de passe inchangé",
  "source_tags": "Étiquettes",
  "source_autotitle_hint": "Laisser vide pour récupérer le titre",
  "source_title": "Titre",
  "source_new": "Nouvelle source non sauvegardée",
  "source_delete": "Supprimer",
  "source_filter": "Filtre",
  "source_edit": "Modifier",
  "source_export": "Exporter les sources",
  "source_opml": "ou importer un fichier OPML ou Google Reader",
  "source_add": "Ajouter une source",
  "loginbutton": "Se connecter",
  "logoutbutton": "Se déconnecter",
  "settingsbutton": "Paramètres",
  "refreshbutton": "Actualiser les sources",
  "searchremove": "Masquer le champ de recherche",
  "searchbutton": "Rechercher",
  "next": "Suivant",
  "open_window": "Ouvrir",
  "load_img": "Afficher les images",
  "unmark": "Marquer comme non lu",
  "mark": "Marquer comme lu",
  "unstar": "Supprimer des favoris",
  "star": "Ajouter aux favoris",
  "days": "{0,plural,zero {aujourd’hui},one {hier},other {il y a # jours}}",
  "seconds": "il y a {0,plural,one {1 seconde},other {# secondes}}",
  "minutes": "il y a {0,plural,one {1 minute},other {# minutes}}",
  "hours": "il y a {0,plural,one {1 heure},other {# heures}}",
  "alltags": "Toutes les étiquettes",
  "tags": "Étiquettes",
  "offline_count": "En local",
  "online_count": "Sur le serveur",
  "starred": "Favoris",
  "unread": "Non lu",
  "newest": "Le plus récent",
  "filter": "Filtrer",
  "markread": "Marquer comme lu",
  "error_offline_storage_not_available": "Le stockage hors ligne n’est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l’API IndexedDB{1} et, si vous utilisez un navigateur basé sur Google Chrome, que vous n’exécutez pas selfoss en mode de navigation privée.",
  "error_edit_source": "Impossible d'enregistrer les modifications de la source :",
  "error_unwritable_logs": "Impossible d'écrire les fichiers de journalisation.",
  "error_check_system_logs": "Une erreur est survenue. Veuillez consulter votre journalisation système.",
  "error_check_log_file": "Une erreur est survenue. Veuillez consulter le fichier « {0} ».",
  "offline_navigation_unavailable": "Modifier les étiquettes et les sources n'est pas possible hors ligne pour le moment."
}
